export default __webpack_public_path__ + "static/media/more-end-game.74af6bfc.md";